import { DTOEngagementStatistic } from "vue-app/api/dto";
import { formatNumberV2 } from "vue-app/utils/functions.ts";

/**
 * This function formats camelCase string key to a readable, lowercase title.
 */
export const formatLocalRejectedKeyToTitle = (key: string): string => {
  return key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .trim()
    .toLowerCase();
};

/**
 * This function sorts local rejected data by its value in descending order, or alphabetically by key name.
 */
export const sortLocalRejectedRows = (
  a: string,
  b: string,
  engagementStatisticsTotal: DTOEngagementStatistic
): number => {
  const valueA = engagementStatisticsTotal[a] ?? 0;
  const valueB = engagementStatisticsTotal[b] ?? 0;

  // First, sort by value in descending order. Else: sort alphabetically by key.
  if (valueB !== valueA) {
    return valueB - valueA;
  }
  return a.localeCompare(b);
};

/**
 * This function extracts unique rejection reasons with their IDs from the input data and returns them as an array.
 */
export function extractReasonsWithIds(data) {
  const uniqueSet = new Set();
  data.forEach((item) => {
    const reasonsObj = JSON.parse(item.reasons);
    Object.entries(reasonsObj).forEach(([trackerProductId, reason]) => {
      uniqueSet.add(JSON.stringify({ trackerProductId, reason }));
    });
  });

  return [...uniqueSet].map((item) => JSON.parse(item as string));
}

export function getMetricLabel(value?: number | null) {
  if (value == null || !value) {
    return "-";
  } else {
    return formatNumberV2(value);
  }
}

export function getMetricLabelWithCurrency(value?: number | null) {
  if (value == null) {
    return "-";
  } else {
    return formatNumberV2(value, { style: "currency", currency: window.EDRONE_CONTEXT.user.currency });
  }
}
